// source: tichatapi/agent.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var chatcontext_chatcontext_pb = require('../chatcontext/chatcontext_pb.js');
goog.object.extend(proto, chatcontext_chatcontext_pb);
var artifact_artifact_pb = require('../artifact/artifact_pb.js');
goog.object.extend(proto, artifact_artifact_pb);
var playbook_playbook_pb = require('../playbook/playbook_pb.js');
goog.object.extend(proto, playbook_playbook_pb);
var common_model_pb = require('../common/model_pb.js');
goog.object.extend(proto, common_model_pb);
goog.exportSymbol('proto.tichatapi.AgentMessage', null, global);
goog.exportSymbol('proto.tichatapi.AgentMessage.ProgressCase', null, global);
goog.exportSymbol('proto.tichatapi.AgentStatus', null, global);
goog.exportSymbol('proto.tichatapi.AgentTimelineEvent', null, global);
goog.exportSymbol('proto.tichatapi.AppCopilotReferringContext', null, global);
goog.exportSymbol('proto.tichatapi.AppCopilotReferringContext.ContextCase', null, global);
goog.exportSymbol('proto.tichatapi.AppCopilotSearchObjectsContext', null, global);
goog.exportSymbol('proto.tichatapi.AppCopilotUniqueObjectContext', null, global);
goog.exportSymbol('proto.tichatapi.ClientMessage', null, global);
goog.exportSymbol('proto.tichatapi.ClientMessageType', null, global);
goog.exportSymbol('proto.tichatapi.ConfirmationDataType', null, global);
goog.exportSymbol('proto.tichatapi.ConfirmationText', null, global);
goog.exportSymbol('proto.tichatapi.Metadata', null, global);
goog.exportSymbol('proto.tichatapi.Progress', null, global);
goog.exportSymbol('proto.tichatapi.Usage', null, global);
goog.exportSymbol('proto.tichatapi.UsageItems', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.ConfirmationText = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tichatapi.ConfirmationText, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.ConfirmationText.displayName = 'proto.tichatapi.ConfirmationText';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.Progress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tichatapi.Progress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.Progress.displayName = 'proto.tichatapi.Progress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.Metadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tichatapi.Metadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.Metadata.displayName = 'proto.tichatapi.Metadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.Usage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tichatapi.Usage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.Usage.displayName = 'proto.tichatapi.Usage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.UsageItems = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tichatapi.UsageItems.repeatedFields_, null);
};
goog.inherits(proto.tichatapi.UsageItems, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.UsageItems.displayName = 'proto.tichatapi.UsageItems';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.AgentTimelineEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tichatapi.AgentTimelineEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.AgentTimelineEvent.displayName = 'proto.tichatapi.AgentTimelineEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.AgentMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tichatapi.AgentMessage.repeatedFields_, proto.tichatapi.AgentMessage.oneofGroups_);
};
goog.inherits(proto.tichatapi.AgentMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.AgentMessage.displayName = 'proto.tichatapi.AgentMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.AppCopilotUniqueObjectContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tichatapi.AppCopilotUniqueObjectContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.AppCopilotUniqueObjectContext.displayName = 'proto.tichatapi.AppCopilotUniqueObjectContext';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.AppCopilotSearchObjectsContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tichatapi.AppCopilotSearchObjectsContext.repeatedFields_, null);
};
goog.inherits(proto.tichatapi.AppCopilotSearchObjectsContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.AppCopilotSearchObjectsContext.displayName = 'proto.tichatapi.AppCopilotSearchObjectsContext';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.AppCopilotReferringContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.tichatapi.AppCopilotReferringContext.oneofGroups_);
};
goog.inherits(proto.tichatapi.AppCopilotReferringContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.AppCopilotReferringContext.displayName = 'proto.tichatapi.AppCopilotReferringContext';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tichatapi.ClientMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tichatapi.ClientMessage.repeatedFields_, null);
};
goog.inherits(proto.tichatapi.ClientMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tichatapi.ClientMessage.displayName = 'proto.tichatapi.ClientMessage';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.ConfirmationText.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.ConfirmationText.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.ConfirmationText} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.ConfirmationText.toObject = function(includeInstance, msg) {
  var f, obj = {
    yes: jspb.Message.getFieldWithDefault(msg, 1, ""),
    no: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.ConfirmationText}
 */
proto.tichatapi.ConfirmationText.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.ConfirmationText;
  return proto.tichatapi.ConfirmationText.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.ConfirmationText} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.ConfirmationText}
 */
proto.tichatapi.ConfirmationText.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setYes(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.ConfirmationText.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.ConfirmationText.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.ConfirmationText} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.ConfirmationText.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getYes();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string yes = 1;
 * @return {string}
 */
proto.tichatapi.ConfirmationText.prototype.getYes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ConfirmationText} returns this
 */
proto.tichatapi.ConfirmationText.prototype.setYes = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string no = 2;
 * @return {string}
 */
proto.tichatapi.ConfirmationText.prototype.getNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ConfirmationText} returns this
 */
proto.tichatapi.ConfirmationText.prototype.setNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.Progress.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.Progress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.Progress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.Progress.toObject = function(includeInstance, msg) {
  var f, obj = {
    current: jspb.Message.getFieldWithDefault(msg, 1, 0),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.Progress}
 */
proto.tichatapi.Progress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.Progress;
  return proto.tichatapi.Progress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.Progress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.Progress}
 */
proto.tichatapi.Progress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.Progress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.Progress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.Progress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.Progress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrent();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 current = 1;
 * @return {number}
 */
proto.tichatapi.Progress.prototype.getCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.Progress} returns this
 */
proto.tichatapi.Progress.prototype.setCurrent = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.tichatapi.Progress.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.Progress} returns this
 */
proto.tichatapi.Progress.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.Metadata.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.Metadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.Metadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.Metadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    promptTokens: jspb.Message.getFieldWithDefault(msg, 1, 0),
    completionTokens: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reqStartTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reqEndTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
    reqWallTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    model: jspb.Message.getFieldWithDefault(msg, 6, ""),
    agentName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    artifactType: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.Metadata}
 */
proto.tichatapi.Metadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.Metadata;
  return proto.tichatapi.Metadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.Metadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.Metadata}
 */
proto.tichatapi.Metadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPromptTokens(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCompletionTokens(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReqStartTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReqEndTime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReqWallTime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgentName(value);
      break;
    case 8:
      var value = /** @type {!proto.artifact.ArtifactType} */ (reader.readEnum());
      msg.setArtifactType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.Metadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.Metadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.Metadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.Metadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromptTokens();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCompletionTokens();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getReqStartTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReqEndTime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReqWallTime();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAgentName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getArtifactType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional uint32 prompt_tokens = 1;
 * @return {number}
 */
proto.tichatapi.Metadata.prototype.getPromptTokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.Metadata} returns this
 */
proto.tichatapi.Metadata.prototype.setPromptTokens = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 completion_tokens = 2;
 * @return {number}
 */
proto.tichatapi.Metadata.prototype.getCompletionTokens = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.Metadata} returns this
 */
proto.tichatapi.Metadata.prototype.setCompletionTokens = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string req_start_time = 3;
 * @return {string}
 */
proto.tichatapi.Metadata.prototype.getReqStartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.Metadata} returns this
 */
proto.tichatapi.Metadata.prototype.setReqStartTime = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string req_end_time = 4;
 * @return {string}
 */
proto.tichatapi.Metadata.prototype.getReqEndTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.Metadata} returns this
 */
proto.tichatapi.Metadata.prototype.setReqEndTime = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double req_wall_time = 5;
 * @return {number}
 */
proto.tichatapi.Metadata.prototype.getReqWallTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.Metadata} returns this
 */
proto.tichatapi.Metadata.prototype.setReqWallTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string model = 6;
 * @return {string}
 */
proto.tichatapi.Metadata.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.Metadata} returns this
 */
proto.tichatapi.Metadata.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string agent_name = 7;
 * @return {string}
 */
proto.tichatapi.Metadata.prototype.getAgentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.Metadata} returns this
 */
proto.tichatapi.Metadata.prototype.setAgentName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional artifact.ArtifactType artifact_type = 8;
 * @return {!proto.artifact.ArtifactType}
 */
proto.tichatapi.Metadata.prototype.getArtifactType = function() {
  return /** @type {!proto.artifact.ArtifactType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.artifact.ArtifactType} value
 * @return {!proto.tichatapi.Metadata} returns this
 */
proto.tichatapi.Metadata.prototype.setArtifactType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.Usage.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.Usage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.Usage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.Usage.toObject = function(includeInstance, msg) {
  var f, obj = {
    questions: jspb.Message.getFieldWithDefault(msg, 1, 0),
    dimensionsMap: (f = msg.getDimensionsMap()) ? f.toObject(includeInstance, undefined) : [],
    timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.Usage}
 */
proto.tichatapi.Usage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.Usage;
  return proto.tichatapi.Usage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.Usage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.Usage}
 */
proto.tichatapi.Usage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setQuestions(value);
      break;
    case 2:
      var value = msg.getDimensionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.Usage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.Usage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.Usage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.Usage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestions();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getDimensionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional uint32 questions = 1;
 * @return {number}
 */
proto.tichatapi.Usage.prototype.getQuestions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.Usage} returns this
 */
proto.tichatapi.Usage.prototype.setQuestions = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * map<string, string> dimensions = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.tichatapi.Usage.prototype.getDimensionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.tichatapi.Usage} returns this
 */
proto.tichatapi.Usage.prototype.clearDimensionsMap = function() {
  this.getDimensionsMap().clear();
  return this;};


/**
 * optional uint64 timestamp = 3;
 * @return {number}
 */
proto.tichatapi.Usage.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.Usage} returns this
 */
proto.tichatapi.Usage.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tichatapi.UsageItems.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.UsageItems.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.UsageItems.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.UsageItems} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.UsageItems.toObject = function(includeInstance, msg) {
  var f, obj = {
    usageList: jspb.Message.toObjectList(msg.getUsageList(),
    proto.tichatapi.Usage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.UsageItems}
 */
proto.tichatapi.UsageItems.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.UsageItems;
  return proto.tichatapi.UsageItems.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.UsageItems} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.UsageItems}
 */
proto.tichatapi.UsageItems.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tichatapi.Usage;
      reader.readMessage(value,proto.tichatapi.Usage.deserializeBinaryFromReader);
      msg.addUsage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.UsageItems.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.UsageItems.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.UsageItems} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.UsageItems.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsageList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tichatapi.Usage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Usage usage = 1;
 * @return {!Array<!proto.tichatapi.Usage>}
 */
proto.tichatapi.UsageItems.prototype.getUsageList = function() {
  return /** @type{!Array<!proto.tichatapi.Usage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tichatapi.Usage, 1));
};


/**
 * @param {!Array<!proto.tichatapi.Usage>} value
 * @return {!proto.tichatapi.UsageItems} returns this
*/
proto.tichatapi.UsageItems.prototype.setUsageList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tichatapi.Usage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tichatapi.Usage}
 */
proto.tichatapi.UsageItems.prototype.addUsage = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tichatapi.Usage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tichatapi.UsageItems} returns this
 */
proto.tichatapi.UsageItems.prototype.clearUsageList = function() {
  return this.setUsageList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.AgentTimelineEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.AgentTimelineEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.AgentTimelineEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AgentTimelineEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    artifactId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sourceKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    badge: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.AgentTimelineEvent}
 */
proto.tichatapi.AgentTimelineEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.AgentTimelineEvent;
  return proto.tichatapi.AgentTimelineEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.AgentTimelineEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.AgentTimelineEvent}
 */
proto.tichatapi.AgentTimelineEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setArtifactId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceKey(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBadge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.AgentTimelineEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.AgentTimelineEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.AgentTimelineEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AgentTimelineEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSourceKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBadge();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.tichatapi.AgentTimelineEvent.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentTimelineEvent} returns this
 */
proto.tichatapi.AgentTimelineEvent.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.tichatapi.AgentTimelineEvent.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentTimelineEvent} returns this
 */
proto.tichatapi.AgentTimelineEvent.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string artifact_id = 3;
 * @return {string}
 */
proto.tichatapi.AgentTimelineEvent.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentTimelineEvent} returns this
 */
proto.tichatapi.AgentTimelineEvent.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string source_key = 4;
 * @return {string}
 */
proto.tichatapi.AgentTimelineEvent.prototype.getSourceKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentTimelineEvent} returns this
 */
proto.tichatapi.AgentTimelineEvent.prototype.setSourceKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string badge = 5;
 * @return {string}
 */
proto.tichatapi.AgentTimelineEvent.prototype.getBadge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentTimelineEvent} returns this
 */
proto.tichatapi.AgentTimelineEvent.prototype.setBadge = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tichatapi.AgentMessage.repeatedFields_ = [3,4,13,19,21];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tichatapi.AgentMessage.oneofGroups_ = [[9,10]];

/**
 * @enum {number}
 */
proto.tichatapi.AgentMessage.ProgressCase = {
  PROGRESS_NOT_SET: 0,
  BUSY: 9,
  PERCENT: 10
};

/**
 * @return {proto.tichatapi.AgentMessage.ProgressCase}
 */
proto.tichatapi.AgentMessage.prototype.getProgressCase = function() {
  return /** @type {proto.tichatapi.AgentMessage.ProgressCase} */(jspb.Message.computeOneofCase(this, proto.tichatapi.AgentMessage.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.AgentMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.AgentMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.AgentMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AgentMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, ""),
    citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    chatcontext_chatcontext_pb.ChatCitation.toObject, includeInstance),
    metadataList: jspb.Message.toObjectList(msg.getMetadataList(),
    proto.tichatapi.Metadata.toObject, includeInstance),
    agentName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    checkpointId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    busy: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    percent: (f = msg.getPercent()) && proto.tichatapi.Progress.toObject(includeInstance, f),
    confirmationDataType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    confirmationText: (f = msg.getConfirmationText()) && proto.tichatapi.ConfirmationText.toObject(includeInstance, f),
    artifactIdsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    chatContextVersion: jspb.Message.getFieldWithDefault(msg, 14, 0),
    chatTitle: jspb.Message.getFieldWithDefault(msg, 15, ""),
    followUpPrompt: jspb.Message.getFieldWithDefault(msg, 16, ""),
    progressCancellable: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    usageItemsList: jspb.Message.toObjectList(msg.getUsageItemsList(),
    proto.tichatapi.Usage.toObject, includeInstance),
    playbookRunId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    fileDownloadsList: jspb.Message.toObjectList(msg.getFileDownloadsList(),
    common_model_pb.FileUpload.toObject, includeInstance),
    timelineEvent: (f = msg.getTimelineEvent()) && proto.tichatapi.AgentTimelineEvent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.AgentMessage}
 */
proto.tichatapi.AgentMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.AgentMessage;
  return proto.tichatapi.AgentMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.AgentMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.AgentMessage}
 */
proto.tichatapi.AgentMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 3:
      var value = new chatcontext_chatcontext_pb.ChatCitation;
      reader.readMessage(value,chatcontext_chatcontext_pb.ChatCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    case 4:
      var value = new proto.tichatapi.Metadata;
      reader.readMessage(value,proto.tichatapi.Metadata.deserializeBinaryFromReader);
      msg.addMetadata(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgentName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckpointId(value);
      break;
    case 8:
      var value = /** @type {!proto.tichatapi.AgentStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBusy(value);
      break;
    case 10:
      var value = new proto.tichatapi.Progress;
      reader.readMessage(value,proto.tichatapi.Progress.deserializeBinaryFromReader);
      msg.setPercent(value);
      break;
    case 11:
      var value = /** @type {!proto.tichatapi.ConfirmationDataType} */ (reader.readEnum());
      msg.setConfirmationDataType(value);
      break;
    case 12:
      var value = new proto.tichatapi.ConfirmationText;
      reader.readMessage(value,proto.tichatapi.ConfirmationText.deserializeBinaryFromReader);
      msg.setConfirmationText(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addArtifactIds(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChatContextVersion(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatTitle(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFollowUpPrompt(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProgressCancellable(value);
      break;
    case 19:
      var value = new proto.tichatapi.Usage;
      reader.readMessage(value,proto.tichatapi.Usage.deserializeBinaryFromReader);
      msg.addUsageItems(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookRunId(value);
      break;
    case 21:
      var value = new common_model_pb.FileUpload;
      reader.readMessage(value,common_model_pb.FileUpload.deserializeBinaryFromReader);
      msg.addFileDownloads(value);
      break;
    case 22:
      var value = new proto.tichatapi.AgentTimelineEvent;
      reader.readMessage(value,proto.tichatapi.AgentTimelineEvent.deserializeBinaryFromReader);
      msg.setTimelineEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.AgentMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.AgentMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.AgentMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AgentMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      chatcontext_chatcontext_pb.ChatCitation.serializeBinaryToWriter
    );
  }
  f = message.getMetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tichatapi.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getAgentName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCheckpointId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getPercent();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.tichatapi.Progress.serializeBinaryToWriter
    );
  }
  f = message.getConfirmationDataType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getConfirmationText();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.tichatapi.ConfirmationText.serializeBinaryToWriter
    );
  }
  f = message.getArtifactIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getChatContextVersion();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getChatTitle();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFollowUpPrompt();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getProgressCancellable();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getUsageItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.tichatapi.Usage.serializeBinaryToWriter
    );
  }
  f = message.getPlaybookRunId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getFileDownloadsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      common_model_pb.FileUpload.serializeBinaryToWriter
    );
  }
  f = message.getTimelineEvent();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.tichatapi.AgentTimelineEvent.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.tichatapi.AgentMessage.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.tichatapi.AgentMessage.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated chatcontext.ChatCitation citations = 3;
 * @return {!Array<!proto.chatcontext.ChatCitation>}
 */
proto.tichatapi.AgentMessage.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.chatcontext.ChatCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, chatcontext_chatcontext_pb.ChatCitation, 3));
};


/**
 * @param {!Array<!proto.chatcontext.ChatCitation>} value
 * @return {!proto.tichatapi.AgentMessage} returns this
*/
proto.tichatapi.AgentMessage.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.chatcontext.ChatCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.chatcontext.ChatCitation}
 */
proto.tichatapi.AgentMessage.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.chatcontext.ChatCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};


/**
 * repeated Metadata metadata = 4;
 * @return {!Array<!proto.tichatapi.Metadata>}
 */
proto.tichatapi.AgentMessage.prototype.getMetadataList = function() {
  return /** @type{!Array<!proto.tichatapi.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tichatapi.Metadata, 4));
};


/**
 * @param {!Array<!proto.tichatapi.Metadata>} value
 * @return {!proto.tichatapi.AgentMessage} returns this
*/
proto.tichatapi.AgentMessage.prototype.setMetadataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tichatapi.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tichatapi.Metadata}
 */
proto.tichatapi.AgentMessage.prototype.addMetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tichatapi.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearMetadataList = function() {
  return this.setMetadataList([]);
};


/**
 * optional string agent_name = 6;
 * @return {string}
 */
proto.tichatapi.AgentMessage.prototype.getAgentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setAgentName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string checkpoint_id = 7;
 * @return {string}
 */
proto.tichatapi.AgentMessage.prototype.getCheckpointId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setCheckpointId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional AgentStatus status = 8;
 * @return {!proto.tichatapi.AgentStatus}
 */
proto.tichatapi.AgentMessage.prototype.getStatus = function() {
  return /** @type {!proto.tichatapi.AgentStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.tichatapi.AgentStatus} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional bool busy = 9;
 * @return {boolean}
 */
proto.tichatapi.AgentMessage.prototype.getBusy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setBusy = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.tichatapi.AgentMessage.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearBusy = function() {
  return jspb.Message.setOneofField(this, 9, proto.tichatapi.AgentMessage.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tichatapi.AgentMessage.prototype.hasBusy = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Progress percent = 10;
 * @return {?proto.tichatapi.Progress}
 */
proto.tichatapi.AgentMessage.prototype.getPercent = function() {
  return /** @type{?proto.tichatapi.Progress} */ (
    jspb.Message.getWrapperField(this, proto.tichatapi.Progress, 10));
};


/**
 * @param {?proto.tichatapi.Progress|undefined} value
 * @return {!proto.tichatapi.AgentMessage} returns this
*/
proto.tichatapi.AgentMessage.prototype.setPercent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.tichatapi.AgentMessage.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearPercent = function() {
  return this.setPercent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tichatapi.AgentMessage.prototype.hasPercent = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional ConfirmationDataType confirmation_data_type = 11;
 * @return {!proto.tichatapi.ConfirmationDataType}
 */
proto.tichatapi.AgentMessage.prototype.getConfirmationDataType = function() {
  return /** @type {!proto.tichatapi.ConfirmationDataType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.tichatapi.ConfirmationDataType} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setConfirmationDataType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional ConfirmationText confirmation_text = 12;
 * @return {?proto.tichatapi.ConfirmationText}
 */
proto.tichatapi.AgentMessage.prototype.getConfirmationText = function() {
  return /** @type{?proto.tichatapi.ConfirmationText} */ (
    jspb.Message.getWrapperField(this, proto.tichatapi.ConfirmationText, 12));
};


/**
 * @param {?proto.tichatapi.ConfirmationText|undefined} value
 * @return {!proto.tichatapi.AgentMessage} returns this
*/
proto.tichatapi.AgentMessage.prototype.setConfirmationText = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearConfirmationText = function() {
  return this.setConfirmationText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tichatapi.AgentMessage.prototype.hasConfirmationText = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated string artifact_ids = 13;
 * @return {!Array<string>}
 */
proto.tichatapi.AgentMessage.prototype.getArtifactIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setArtifactIdsList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.addArtifactIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearArtifactIdsList = function() {
  return this.setArtifactIdsList([]);
};


/**
 * optional int32 chat_context_version = 14;
 * @return {number}
 */
proto.tichatapi.AgentMessage.prototype.getChatContextVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setChatContextVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string chat_title = 15;
 * @return {string}
 */
proto.tichatapi.AgentMessage.prototype.getChatTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setChatTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string follow_up_prompt = 16;
 * @return {string}
 */
proto.tichatapi.AgentMessage.prototype.getFollowUpPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setFollowUpPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional bool progress_cancellable = 17;
 * @return {boolean}
 */
proto.tichatapi.AgentMessage.prototype.getProgressCancellable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setProgressCancellable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * repeated Usage usage_items = 19;
 * @return {!Array<!proto.tichatapi.Usage>}
 */
proto.tichatapi.AgentMessage.prototype.getUsageItemsList = function() {
  return /** @type{!Array<!proto.tichatapi.Usage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tichatapi.Usage, 19));
};


/**
 * @param {!Array<!proto.tichatapi.Usage>} value
 * @return {!proto.tichatapi.AgentMessage} returns this
*/
proto.tichatapi.AgentMessage.prototype.setUsageItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.tichatapi.Usage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tichatapi.Usage}
 */
proto.tichatapi.AgentMessage.prototype.addUsageItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.tichatapi.Usage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearUsageItemsList = function() {
  return this.setUsageItemsList([]);
};


/**
 * optional string playbook_run_id = 20;
 * @return {string}
 */
proto.tichatapi.AgentMessage.prototype.getPlaybookRunId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.setPlaybookRunId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * repeated common.FileUpload file_downloads = 21;
 * @return {!Array<!proto.common.FileUpload>}
 */
proto.tichatapi.AgentMessage.prototype.getFileDownloadsList = function() {
  return /** @type{!Array<!proto.common.FileUpload>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_model_pb.FileUpload, 21));
};


/**
 * @param {!Array<!proto.common.FileUpload>} value
 * @return {!proto.tichatapi.AgentMessage} returns this
*/
proto.tichatapi.AgentMessage.prototype.setFileDownloadsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.common.FileUpload=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.FileUpload}
 */
proto.tichatapi.AgentMessage.prototype.addFileDownloads = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.common.FileUpload, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearFileDownloadsList = function() {
  return this.setFileDownloadsList([]);
};


/**
 * optional AgentTimelineEvent timeline_event = 22;
 * @return {?proto.tichatapi.AgentTimelineEvent}
 */
proto.tichatapi.AgentMessage.prototype.getTimelineEvent = function() {
  return /** @type{?proto.tichatapi.AgentTimelineEvent} */ (
    jspb.Message.getWrapperField(this, proto.tichatapi.AgentTimelineEvent, 22));
};


/**
 * @param {?proto.tichatapi.AgentTimelineEvent|undefined} value
 * @return {!proto.tichatapi.AgentMessage} returns this
*/
proto.tichatapi.AgentMessage.prototype.setTimelineEvent = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tichatapi.AgentMessage} returns this
 */
proto.tichatapi.AgentMessage.prototype.clearTimelineEvent = function() {
  return this.setTimelineEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tichatapi.AgentMessage.prototype.hasTimelineEvent = function() {
  return jspb.Message.getField(this, 22) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.AppCopilotUniqueObjectContext.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.AppCopilotUniqueObjectContext.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.AppCopilotUniqueObjectContext} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AppCopilotUniqueObjectContext.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    objectId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.AppCopilotUniqueObjectContext}
 */
proto.tichatapi.AppCopilotUniqueObjectContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.AppCopilotUniqueObjectContext;
  return proto.tichatapi.AppCopilotUniqueObjectContext.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.AppCopilotUniqueObjectContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.AppCopilotUniqueObjectContext}
 */
proto.tichatapi.AppCopilotUniqueObjectContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setObjectType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.AppCopilotUniqueObjectContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.AppCopilotUniqueObjectContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.AppCopilotUniqueObjectContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AppCopilotUniqueObjectContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getObjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.MODEL_TYPE object_type = 1;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.tichatapi.AppCopilotUniqueObjectContext.prototype.getObjectType = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.tichatapi.AppCopilotUniqueObjectContext} returns this
 */
proto.tichatapi.AppCopilotUniqueObjectContext.prototype.setObjectType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string object_id = 2;
 * @return {string}
 */
proto.tichatapi.AppCopilotUniqueObjectContext.prototype.getObjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AppCopilotUniqueObjectContext} returns this
 */
proto.tichatapi.AppCopilotUniqueObjectContext.prototype.setObjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tichatapi.AppCopilotSearchObjectsContext.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.AppCopilotSearchObjectsContext.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.AppCopilotSearchObjectsContext} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AppCopilotSearchObjectsContext.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    resultsCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    objectIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    filterQuery: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.AppCopilotSearchObjectsContext}
 */
proto.tichatapi.AppCopilotSearchObjectsContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.AppCopilotSearchObjectsContext;
  return proto.tichatapi.AppCopilotSearchObjectsContext.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.AppCopilotSearchObjectsContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.AppCopilotSearchObjectsContext}
 */
proto.tichatapi.AppCopilotSearchObjectsContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setObjectType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResultsCount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addObjectIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.AppCopilotSearchObjectsContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.AppCopilotSearchObjectsContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AppCopilotSearchObjectsContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResultsCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getObjectIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getFilterQuery();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional common.MODEL_TYPE object_type = 1;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.getObjectType = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.tichatapi.AppCopilotSearchObjectsContext} returns this
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.setObjectType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 results_count = 2;
 * @return {number}
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.getResultsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tichatapi.AppCopilotSearchObjectsContext} returns this
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.setResultsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string object_ids = 3;
 * @return {!Array<string>}
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.getObjectIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tichatapi.AppCopilotSearchObjectsContext} returns this
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.setObjectIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tichatapi.AppCopilotSearchObjectsContext} returns this
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.addObjectIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tichatapi.AppCopilotSearchObjectsContext} returns this
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.clearObjectIdsList = function() {
  return this.setObjectIdsList([]);
};


/**
 * optional string filter_query = 4;
 * @return {string}
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.getFilterQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.AppCopilotSearchObjectsContext} returns this
 */
proto.tichatapi.AppCopilotSearchObjectsContext.prototype.setFilterQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tichatapi.AppCopilotReferringContext.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.tichatapi.AppCopilotReferringContext.ContextCase = {
  CONTEXT_NOT_SET: 0,
  UNIQUE_OBJECT: 1,
  SEARCH_OBJECTS: 2
};

/**
 * @return {proto.tichatapi.AppCopilotReferringContext.ContextCase}
 */
proto.tichatapi.AppCopilotReferringContext.prototype.getContextCase = function() {
  return /** @type {proto.tichatapi.AppCopilotReferringContext.ContextCase} */(jspb.Message.computeOneofCase(this, proto.tichatapi.AppCopilotReferringContext.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.AppCopilotReferringContext.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.AppCopilotReferringContext.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.AppCopilotReferringContext} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AppCopilotReferringContext.toObject = function(includeInstance, msg) {
  var f, obj = {
    uniqueObject: (f = msg.getUniqueObject()) && proto.tichatapi.AppCopilotUniqueObjectContext.toObject(includeInstance, f),
    searchObjects: (f = msg.getSearchObjects()) && proto.tichatapi.AppCopilotSearchObjectsContext.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.AppCopilotReferringContext}
 */
proto.tichatapi.AppCopilotReferringContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.AppCopilotReferringContext;
  return proto.tichatapi.AppCopilotReferringContext.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.AppCopilotReferringContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.AppCopilotReferringContext}
 */
proto.tichatapi.AppCopilotReferringContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tichatapi.AppCopilotUniqueObjectContext;
      reader.readMessage(value,proto.tichatapi.AppCopilotUniqueObjectContext.deserializeBinaryFromReader);
      msg.setUniqueObject(value);
      break;
    case 2:
      var value = new proto.tichatapi.AppCopilotSearchObjectsContext;
      reader.readMessage(value,proto.tichatapi.AppCopilotSearchObjectsContext.deserializeBinaryFromReader);
      msg.setSearchObjects(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.AppCopilotReferringContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.AppCopilotReferringContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.AppCopilotReferringContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.AppCopilotReferringContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUniqueObject();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.tichatapi.AppCopilotUniqueObjectContext.serializeBinaryToWriter
    );
  }
  f = message.getSearchObjects();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tichatapi.AppCopilotSearchObjectsContext.serializeBinaryToWriter
    );
  }
};


/**
 * optional AppCopilotUniqueObjectContext unique_object = 1;
 * @return {?proto.tichatapi.AppCopilotUniqueObjectContext}
 */
proto.tichatapi.AppCopilotReferringContext.prototype.getUniqueObject = function() {
  return /** @type{?proto.tichatapi.AppCopilotUniqueObjectContext} */ (
    jspb.Message.getWrapperField(this, proto.tichatapi.AppCopilotUniqueObjectContext, 1));
};


/**
 * @param {?proto.tichatapi.AppCopilotUniqueObjectContext|undefined} value
 * @return {!proto.tichatapi.AppCopilotReferringContext} returns this
*/
proto.tichatapi.AppCopilotReferringContext.prototype.setUniqueObject = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.tichatapi.AppCopilotReferringContext.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tichatapi.AppCopilotReferringContext} returns this
 */
proto.tichatapi.AppCopilotReferringContext.prototype.clearUniqueObject = function() {
  return this.setUniqueObject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tichatapi.AppCopilotReferringContext.prototype.hasUniqueObject = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AppCopilotSearchObjectsContext search_objects = 2;
 * @return {?proto.tichatapi.AppCopilotSearchObjectsContext}
 */
proto.tichatapi.AppCopilotReferringContext.prototype.getSearchObjects = function() {
  return /** @type{?proto.tichatapi.AppCopilotSearchObjectsContext} */ (
    jspb.Message.getWrapperField(this, proto.tichatapi.AppCopilotSearchObjectsContext, 2));
};


/**
 * @param {?proto.tichatapi.AppCopilotSearchObjectsContext|undefined} value
 * @return {!proto.tichatapi.AppCopilotReferringContext} returns this
*/
proto.tichatapi.AppCopilotReferringContext.prototype.setSearchObjects = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.tichatapi.AppCopilotReferringContext.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tichatapi.AppCopilotReferringContext} returns this
 */
proto.tichatapi.AppCopilotReferringContext.prototype.clearSearchObjects = function() {
  return this.setSearchObjects(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tichatapi.AppCopilotReferringContext.prototype.hasSearchObjects = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tichatapi.ClientMessage.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tichatapi.ClientMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.tichatapi.ClientMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tichatapi.ClientMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.ClientMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    messageType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    chatContextId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    chatHistoryId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    checkpointId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    summarizeChatTitle: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    playbookInputs: (f = msg.getPlaybookInputs()) && playbook_playbook_pb.PlaybookInputs.toObject(includeInstance, f),
    fileUploadsList: jspb.Message.toObjectList(msg.getFileUploadsList(),
    common_model_pb.FileUpload.toObject, includeInstance),
    questionId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    promptOverridesSourceId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    referringContext: (f = msg.getReferringContext()) && proto.tichatapi.AppCopilotReferringContext.toObject(includeInstance, f),
    userId: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tichatapi.ClientMessage}
 */
proto.tichatapi.ClientMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tichatapi.ClientMessage;
  return proto.tichatapi.ClientMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tichatapi.ClientMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tichatapi.ClientMessage}
 */
proto.tichatapi.ClientMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {!proto.tichatapi.ClientMessageType} */ (reader.readEnum());
      msg.setMessageType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatContextId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatHistoryId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckpointId(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSummarizeChatTitle(value);
      break;
    case 8:
      var value = new playbook_playbook_pb.PlaybookInputs;
      reader.readMessage(value,playbook_playbook_pb.PlaybookInputs.deserializeBinaryFromReader);
      msg.setPlaybookInputs(value);
      break;
    case 9:
      var value = new common_model_pb.FileUpload;
      reader.readMessage(value,common_model_pb.FileUpload.deserializeBinaryFromReader);
      msg.addFileUploads(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromptOverridesSourceId(value);
      break;
    case 12:
      var value = new proto.tichatapi.AppCopilotReferringContext;
      reader.readMessage(value,proto.tichatapi.AppCopilotReferringContext.deserializeBinaryFromReader);
      msg.setReferringContext(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tichatapi.ClientMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tichatapi.ClientMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tichatapi.ClientMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tichatapi.ClientMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessageType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChatContextId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getChatHistoryId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCheckpointId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSummarizeChatTitle();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPlaybookInputs();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      playbook_playbook_pb.PlaybookInputs.serializeBinaryToWriter
    );
  }
  f = message.getFileUploadsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      common_model_pb.FileUpload.serializeBinaryToWriter
    );
  }
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPromptOverridesSourceId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getReferringContext();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.tichatapi.AppCopilotReferringContext.serializeBinaryToWriter
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.tichatapi.ClientMessage.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ClientMessageType message_type = 2;
 * @return {!proto.tichatapi.ClientMessageType}
 */
proto.tichatapi.ClientMessage.prototype.getMessageType = function() {
  return /** @type {!proto.tichatapi.ClientMessageType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.tichatapi.ClientMessageType} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setMessageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string account_id = 3;
 * @return {string}
 */
proto.tichatapi.ClientMessage.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string chat_context_id = 4;
 * @return {string}
 */
proto.tichatapi.ClientMessage.prototype.getChatContextId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setChatContextId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string chat_history_id = 5;
 * @return {string}
 */
proto.tichatapi.ClientMessage.prototype.getChatHistoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setChatHistoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string checkpoint_id = 6;
 * @return {string}
 */
proto.tichatapi.ClientMessage.prototype.getCheckpointId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setCheckpointId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool summarize_chat_title = 7;
 * @return {boolean}
 */
proto.tichatapi.ClientMessage.prototype.getSummarizeChatTitle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setSummarizeChatTitle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional playbook.PlaybookInputs playbook_inputs = 8;
 * @return {?proto.playbook.PlaybookInputs}
 */
proto.tichatapi.ClientMessage.prototype.getPlaybookInputs = function() {
  return /** @type{?proto.playbook.PlaybookInputs} */ (
    jspb.Message.getWrapperField(this, playbook_playbook_pb.PlaybookInputs, 8));
};


/**
 * @param {?proto.playbook.PlaybookInputs|undefined} value
 * @return {!proto.tichatapi.ClientMessage} returns this
*/
proto.tichatapi.ClientMessage.prototype.setPlaybookInputs = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.clearPlaybookInputs = function() {
  return this.setPlaybookInputs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tichatapi.ClientMessage.prototype.hasPlaybookInputs = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated common.FileUpload file_uploads = 9;
 * @return {!Array<!proto.common.FileUpload>}
 */
proto.tichatapi.ClientMessage.prototype.getFileUploadsList = function() {
  return /** @type{!Array<!proto.common.FileUpload>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_model_pb.FileUpload, 9));
};


/**
 * @param {!Array<!proto.common.FileUpload>} value
 * @return {!proto.tichatapi.ClientMessage} returns this
*/
proto.tichatapi.ClientMessage.prototype.setFileUploadsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.common.FileUpload=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.FileUpload}
 */
proto.tichatapi.ClientMessage.prototype.addFileUploads = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.common.FileUpload, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.clearFileUploadsList = function() {
  return this.setFileUploadsList([]);
};


/**
 * optional string question_id = 10;
 * @return {string}
 */
proto.tichatapi.ClientMessage.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string prompt_overrides_source_id = 11;
 * @return {string}
 */
proto.tichatapi.ClientMessage.prototype.getPromptOverridesSourceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setPromptOverridesSourceId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional AppCopilotReferringContext referring_context = 12;
 * @return {?proto.tichatapi.AppCopilotReferringContext}
 */
proto.tichatapi.ClientMessage.prototype.getReferringContext = function() {
  return /** @type{?proto.tichatapi.AppCopilotReferringContext} */ (
    jspb.Message.getWrapperField(this, proto.tichatapi.AppCopilotReferringContext, 12));
};


/**
 * @param {?proto.tichatapi.AppCopilotReferringContext|undefined} value
 * @return {!proto.tichatapi.ClientMessage} returns this
*/
proto.tichatapi.ClientMessage.prototype.setReferringContext = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.clearReferringContext = function() {
  return this.setReferringContext(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tichatapi.ClientMessage.prototype.hasReferringContext = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string user_id = 13;
 * @return {string}
 */
proto.tichatapi.ClientMessage.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.tichatapi.ClientMessage} returns this
 */
proto.tichatapi.ClientMessage.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * @enum {number}
 */
proto.tichatapi.AgentStatus = {
  STATUS_START: 0,
  STATUS_PROCESSING: 1,
  STATUS_FEEDBACK: 2,
  STATUS_INTERRUPT: 3,
  STATUS_STOPPING: 4,
  STATUS_COMPLETE: 5,
  STATUS_ERROR: 6,
  STATUS_PING: 7,
  STATUS_DEBUG: 8,
  STATUS_PLAN: 9,
  STATUS_TIMELINE_EVENT: 10
};

/**
 * @enum {number}
 */
proto.tichatapi.ConfirmationDataType = {
  CONFIRM_UNSPECIFIED: 0,
  CONFIRM_DATA_SELECTION: 1,
  CONFIRM_COST: 2
};

/**
 * @enum {number}
 */
proto.tichatapi.ClientMessageType = {
  CLIENT_UNSPECIFIED: 0,
  CLIENT_CONFIRMATION_YES: 1,
  CLIENT_CONFIRMATION_NO: 2
};

goog.object.extend(exports, proto.tichatapi);
